import React from 'react';

export default () => (
  <svg height="38" viewBox="0 0 28 38" width="28">
    <mask id="a" fill="#fff">
      <path d="m0 25.999037h26v-25.999037h-26z" fill="none" />
    </mask>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <path
          d="m25.037037 12.999037c0 6.6492593-5.3897037 12.0370371-12.037037 12.0370371-6.64637037 0-12.03703704-5.3877778-12.03703704-12.0370371 0-6.64637033 5.39066667-12.03607404 12.03703704-12.03607404 6.6473333 0 12.037037 5.38970371 12.037037 12.03607404z"
          stroke="#9556b7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <circle cx="13" cy="13" fill="#f8f6fb" mask="url(#a)" r="11" />
      </g>
      <g transform="translate(12.555556 7.740741)">
        <path
          d="m.61148148 2.1762963h1.66688889v-1.89896297h-1.66688889zm.00962963 10.1534815h1.65822222v-8.23622224h-1.65822222z"
          fill="#9556b7"
        />
        <path
          d="m.61148148 2.1762963h1.66688889v-1.89896297h-1.66688889zm.00962963 10.1534815h1.65822222v-8.23622224h-1.65822222z"
          stroke="#9556b7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".5"
        />
      </g>
      <ellipse cx="14" cy="35.055556" fill="#eee" rx="10" ry="2.055556" />
    </g>
  </svg>
);
